
import { useEffect } from "react";
import { ParallaxProvider } from "react-scroll-parallax";

import Navbar from "./components/NavBar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import SpecialOffer from "./components/SpecialOffer";
import About from "./components/About";
import AboutCIM from "./components/AboutCIM";
import Clients from "./components/Clients";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import PromoPage from "./pages/PromoPage";

import "./App.css";

function App() {
  const isPromoPage = /\/promo\/?$/.test(window.location.pathname);

  useEffect(() => {
    const scrollToHash = () => {
      const sectionId = decodeURIComponent(window.location.hash.slice(1));

      if (!sectionId) return;

      window.requestAnimationFrame(() => {
        const section = document.getElementById(sectionId);

        if (!section) return;

        const root = document.documentElement;
        const previousScrollBehavior = root.style.scrollBehavior;

        root.style.scrollBehavior = "auto";
        section.scrollIntoView({ block: "start" });
        root.style.scrollBehavior = previousScrollBehavior;
      });
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);

    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  if (isPromoPage) {
    return (
      <ParallaxProvider>
        <PromoPage />
      </ParallaxProvider>
    );
  }

  return (
    <ParallaxProvider>
      <div className="App font-sans text-gray-900">
        <Navbar />
        <Hero />
        <About />
        <Services/>
        <SpecialOffer />
        <AboutCIM />
        <Clients />
        <Reviews />
        <Contact />
      </div>
    </ParallaxProvider>
  );
}

export default App;
